module.exports = __webpack_public_path__ + "img/8.34935e4d.png";